import type { Review } from "@/data/reviewTypes";

export const NORFOLK_VA_REVIEWS: Review[] = [
  { name: "Miguel K.", initials: "MK", rating: 5, date: "1 week ago", text: "Norfolk pickup for our 14-person crew — Sprinter was spotless, driver knew every Norfolk shortcut. Booking again for sure." },
  { name: "Sara R.", initials: "SR", rating: 5, date: "3 weeks ago", text: "Bachelorette weekend based in Norfolk. Easy delivery to our Airbnb, captain\u2019s chairs, cold AC all day. Perfect for our group." },
  { name: "Devon T.", initials: "DT", rating: 5, date: "1 month ago", text: "Booked the 15-passenger for a Norfolk event. On-time, full tank, no surprise charges — straight-forward and reliable." },
];
